import { useEffect, useState } from 'react';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const R$ = (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',')}`;

const FEATURES = [
  { key: 'has_landing_page', label: 'Landing Page' },
  { key: 'has_packages',     label: 'Pacotes' },
  { key: 'has_financial',    label: 'Financeiro' },
  { key: 'has_stock',        label: 'Estoque' },
  { key: 'has_commissions',  label: 'Comissões' },
  { key: 'has_checklist',    label: 'Checklist' },
  { key: 'has_reports',      label: 'Relatórios' },
  { key: 'has_whatsapp',     label: 'WhatsApp' },
];

const EMPTY_FORM = {
  name: '', description: '', price_monthly: '', price_yearly: '',
  trial_days: 7, max_users: 5, max_customers: 500,
  has_landing_page: 0, has_packages: 0, has_financial: 1,
  has_stock: 0, has_commissions: 0, has_checklist: 1,
  has_reports: 1, has_whatsapp: 0,
};

const inp = { width: '100%', padding: '8px 12px', border: '1.5px solid #E5E7EB', borderRadius: 8, outline: 'none', fontSize: '.9rem', boxSizing: 'border-box' };
const lbl = { fontSize: '.78rem', fontWeight: 600, color: '#6B7280', display: 'block', marginBottom: 4 };

export default function AdminPlans() {
  const [plans,      setPlans]      = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [editing,    setEditing]    = useState(null); // plan id being edited
  const [creating,   setCreating]   = useState(false);
  const [form,       setForm]       = useState({});

  const load = async () => {
    setLoading(true);
    try { const r = await adminAPI.plans(); setPlans(r.data.data || []); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const flag = (v) => Number(v) === 1 ? 1 : 0;

  const startEdit = (p) => {
    setCreating(false);
    setEditing(p.id);
    setForm({
      name:           p.name          || '',
      description:    p.description   || '',
      price_monthly:  p.price_monthly ?? '',
      price_yearly:   p.price_yearly  ?? '',
      trial_days:     p.trial_days    ?? 7,
      max_users:      p.max_users     ?? 5,
      max_customers:  p.max_customers ?? 500,
      has_landing_page: flag(p.has_landing_page),
      has_packages:     flag(p.has_packages),
      has_financial:    flag(p.has_financial),
      has_stock:        flag(p.has_stock),
      has_commissions:  flag(p.has_commissions),
      has_checklist:    flag(p.has_checklist),
      has_reports:      flag(p.has_reports),
      has_whatsapp:     flag(p.has_whatsapp),
      is_active:        flag(p.is_active),
    });
  };

  const startCreate = () => {
    setEditing(null);
    setCreating(true);
    setForm(EMPTY_FORM);
  };

  const cancel = () => { setEditing(null); setCreating(false); };

  const save = async () => {
    try {
      if (creating) {
        await adminAPI.planCreate(form);
        toast.success('Plano criado!');
      } else {
        await adminAPI.planUpdate(editing, form);
        toast.success('Plano atualizado!');
      }
      cancel();
      load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro ao salvar.'); }
  };

  const isOpen = editing !== null || creating;
  const activePlan = plans.find(p => p.id === editing);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#6B7280' }}>Carregando planos...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#0F172A' }}>Gerenciar Planos</h1>
        <button onClick={startCreate}
          style={{ padding: '9px 20px', background: '#2563EB', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>
          + Novo Plano
        </button>
      </div>

      {/* Lista de planos */}
      <div style={{ display: 'grid', gap: 16 }}>
        {plans.map(p => (
          <div key={p.id} style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, padding: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontWeight: 800, fontSize: '1.1rem', color: '#0F172A' }}>{p.name}</span>
                {!flag(p.is_active) && (
                  <span style={{ fontSize: '.72rem', background: '#FEE2E2', color: '#DC2626', padding: '2px 8px', borderRadius: 20, fontWeight: 600 }}>
                    Inativo
                  </span>
                )}
              </div>
              <button onClick={() => startEdit(p)}
                style={{ padding: '6px 16px', background: '#F3F4F6', color: '#374151', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: '.85rem', fontWeight: 600 }}>
                Editar
              </button>
            </div>

            <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 12, fontSize: '.88rem', color: '#374151' }}>
              <span>Mensal: <strong style={{ color: '#2563EB' }}>{R$(p.price_monthly)}</strong></span>
              <span>Anual: <strong style={{ color: '#2563EB' }}>{R$(p.price_yearly)}</strong></span>
              <span>Teste: <strong>{p.trial_days} dias</strong></span>
              <span>Usuários: <strong>{p.max_users}</strong></span>
              <span>Clientes: <strong>{p.max_customers}</strong></span>
              {p.description && <span style={{ color: '#6B7280' }}>{p.description}</span>}
            </div>

            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {FEATURES.map(({ key, label }) => {
                const on = flag(p[key]);
                return (
                <span key={key} style={{
                  fontSize: '.75rem', fontWeight: 600, padding: '3px 10px', borderRadius: 20,
                  background: on ? '#D1FAE5' : '#F3F4F6',
                  color:      on ? '#059669' : '#9CA3AF',
                }}>
                  {on ? '✓' : '✗'} {label}
                </span>
              );})}
            </div>
          </div>
        ))}
      </div>

      {/* Modal criar / editar */}
      {isOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 640, maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ fontWeight: 700, fontSize: '1.1rem', color: '#0F172A', marginBottom: 24 }}>
              {creating ? 'Novo Plano' : `Editar: ${activePlan?.name}`}
            </h3>

            {/* Dados básicos */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 20 }}>
              <div style={{ gridColumn: '1/-1' }}>
                <label style={lbl}>Nome do plano *</label>
                <input value={form.name || ''} onChange={e => setF('name', e.target.value)} style={inp} placeholder="Ex: Profissional" />
              </div>
              {[
                ['Preço Mensal (R$)', 'price_monthly'],
                ['Preço Anual (R$)',  'price_yearly'],
                ['Dias de Teste',     'trial_days'],
                ['Máx. Usuários',     'max_users'],
                ['Máx. Clientes',     'max_customers'],
              ].map(([label, key]) => (
                <div key={key}>
                  <label style={lbl}>{label}</label>
                  <input type="number" value={form[key] ?? ''} onChange={e => setF(key, e.target.value)} style={inp} />
                </div>
              ))}
              <div style={{ gridColumn: '1/-1' }}>
                <label style={lbl}>Descrição</label>
                <input value={form.description || ''} onChange={e => setF('description', e.target.value)} style={inp} placeholder="Descrição breve do plano" />
              </div>
            </div>

            {/* Funcionalidades */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: '.85rem', fontWeight: 700, color: '#374151', marginBottom: 12 }}>Funcionalidades incluídas</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: 10 }}>
                {FEATURES.map(({ key, label }) => (
                  <label key={key} onClick={() => setF(key, form[key] ? 0 : 1)}
                    style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 10,
                      border: `2px solid ${form[key] ? '#2563EB' : '#E5E7EB'}`,
                      background: form[key] ? '#EFF6FF' : '#F9FAFB',
                      cursor: 'pointer', userSelect: 'none' }}>
                    <div style={{ width: 20, height: 20, borderRadius: 6, border: `2px solid ${form[key] ? '#2563EB' : '#D1D5DB'}`,
                      background: form[key] ? '#2563EB' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {form[key] ? <span style={{ color: '#fff', fontSize: 13, lineHeight: 1 }}>✓</span> : null}
                    </div>
                    <span style={{ fontSize: '.88rem', fontWeight: 600, color: form[key] ? '#1D4ED8' : '#6B7280' }}>{label}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Status (só edição) */}
            {!creating && (
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
                  onClick={() => setF('is_active', form.is_active ? 0 : 1)}>
                  <div style={{ width: 20, height: 20, borderRadius: 6, border: `2px solid ${form.is_active ? '#059669' : '#D1D5DB'}`,
                    background: form.is_active ? '#059669' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {form.is_active ? <span style={{ color: '#fff', fontSize: 13, lineHeight: 1 }}>✓</span> : null}
                  </div>
                  <span style={{ fontSize: '.88rem', fontWeight: 600, color: '#374151' }}>Plano ativo</span>
                </label>
              </div>
            )}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={cancel}
                style={{ padding: '10px 20px', border: '1.5px solid #E5E7EB', borderRadius: 8, background: '#fff', cursor: 'pointer', fontWeight: 600 }}>
                Cancelar
              </button>
              <button onClick={save}
                style={{ padding: '10px 28px', background: '#2563EB', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>
                {creating ? 'Criar Plano' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
